<template>
  <div class="guide-page">
    <div class="bread">
      <router-link class="bread-item" to="/">上上签</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" :to="{name:'embassyHoliday'}">使馆假期</router-link>
    </div>

    <div class="earlist-main">
      <div class="earlist-title">
        <div class="earlist-title-left">使馆假期
          <span>/ 近两月</span>
        </div>
        <el-select class="earlist-title-right" v-model="continentSelect" v-on:change="continentSelectChange">
          <el-option v-for="(item, ind) in continent_name" :key="ind" :label="item" :value="ind">
          </el-option>
        </el-select>
      </div>

      <div class="earlist-content">
        <template v-for="(v, ind) in continent">
          <div class="earlist-content-box" :key="ind" v-if="(ind ===continentSelect-1||continentSelect===0)&&!v.shouldNotShow">
            <div class="earlist-content-left">{{continent_name[v.continent_id+1]}}</div>

            <div class="earlist-content-right">
              <template v-for="(country, index) in v.country">
                <div class="earlist-right-item" :key="index" v-if="country.holiday && country.holiday.length !== 0">
                  <img :src="country.national_flag_img" alt="">
                  <span class="earlist-right-country">{{country.country}}</span>
                  <span class="earlist-right-earlist">
                    <span v-for="hol in country.holiday" :key="hol">{{formatDateWithConcat(hol)}}</span>
                  </span>
                </div>
              </template>
            </div>

          </div>
        </template>

        <div class="earlist-content-no" v-if="noCountryShow">
          <img src="../assets/imgs/earlist-nodata.png" alt="">
          <p>暂无放假日期</p>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import _ from 'lodash';
import Http from '../libs/http';
import dateUtils from '../libs/date-util';

export default {
  data() {
    return {
      dataArr: [],
      continent_name: ['全部使馆', '亚洲', '欧洲', '美洲', '大洋洲', '非洲'],
      old_continent: [],
      countryHolidays: [],
      continent: [],
      allcontinent: [],
      continentSelect: 0,
      noCountryShow: false,
    };
  },
  methods: {
    // 将国家放假日期放进国家数组里
    putinCountryHoliday() {
      this.continent = this.old_continent;

      // 将对应国家的放假日期放进对应的国家数组
      this.continent.forEach((continent) => {

        // 遍历洲里面的国家
        continent.country.forEach((country) => {

          // 国家日历里面的国家id
          Object.keys(this.countryHolidays).forEach((country_id) => {

            // 若国家id相等，放入对应国家对象里面
            if (+country_id === country.visa_country_id) {

              // 过滤掉周末, 过滤60天之后日期
              country.holiday = this.countryHolidays[country_id].filter((date, index) => {

                const holidayTime = new Date(date).getTime();

                // 将当前日期设置为早上8点0分0秒0毫秒
                let now = new Date().setHours(8);
                now = new Date(now).setMinutes(0);
                now = new Date(now).setSeconds(0);
                now = new Date(now).setMilliseconds(0);

                // 设置需要显示的日期的条件
                const isNeedReturnDay = this.setNeedReturnDay(date, this.countryHolidays[country_id], index);
                return (
                  isNeedReturnDay &&
                  holidayTime - now <= 5184000000 &&
                  holidayTime >= now
                );
              });
              country.holiday = _.sortBy(country.holiday, date => new Date(date));
              country.holiday = this.concatDate(country.holiday);
            }
          });
        });
      });

      // 过滤掉没有日期的国家
      this.continent.forEach((continent) => {
        continent.shouldNotShow = continent.country.every(
          country => country.holiday.length === 0,
        );
      });
    },
    // 选择大洲切换
    continentSelectChange(num) {
      this.continentSelect = num;
      this.noCountryShow = this.continent.some(
        val => val.continent_id === num - 1 && val.shouldNotShow,
      );
    },
    formatDateWithWeek: dateUtils.formatDateWithWeek,
    formatDateWithConcat: dateUtils.formatDateWithConcat,
    concatDate: dateUtils.concatDate,
    setNeedReturnDay: dateUtils.setNeedReturnDay,
  },
  created() {
    Http.post('/sys/visa_continent_query')
      .then((data) => {
        this.old_continent = data.continent;
      })
      .then(() => Http.post('/sys/visa_country_holiday_date_query', {}))
      .then((data) => {
        this.countryHolidays = data;
        this.putinCountryHoliday();
        this.$forceUpdate();
      })
      .catch(() => {});
  },
};
</script>

<style lang="less" scoped>
@import "../assets/less/variable";
.guide-page {
  width: 1000px;
  margin: 0 auto 60px;
}

.earlist-main {
  width: 920px;
  border: 1px solid #f0f0f0;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  .earlist-title {
    height: 60px;
    background-color: #fbfbfb;
    font-size: 18px;
    color: #333333;
    line-height: 60px;
    padding-left: 30px;
    padding-right: 30px;
    .earlist-title-left {
      float: left;
      height: 60px;
      span {
        font-size: 14px;
      }
    }
    .earlist-title-right {
      float: right;
      margin-top: 12px;
    }
  }
  .earlist-content {
    min-height: 300px;
    background-color: #ffffff;
    .earlist-content-no {
      background-color: #ffffff;
      height: 300px;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      img {
        margin-top: 83px;
      }
      p {
        font-size: 12px;
        color: #777777;
        margin-top: 14px;
      }
    }

    .earlist-content-box {
      display: flex;
      background-color: #ffffff;
      padding: 30px 30px 0 30px;
      position: relative;
      &:nth-of-type(2n) {
        background-color: #fbfbfb;
      }
      .earlist-content-left {
        flex-shrink: 0;
        font-size: 24px;
        position: relative;
        z-index: 10;
        width: 72px;
      }
      .earlist-content-right {
        margin-left: 30px;
        padding-top: 4px;
        .earlist-right-item {
          padding-bottom: 20px;
          padding-top: 20px;
          font-size: 14px;
          display: flex;
          border-bottom: 1px solid #f0f0f0;
          &:nth-of-type(1) {
            padding-top: 0px;
          }
          &:nth-last-child(1) {
            border-bottom: none;
          }
          img {
            width: 31px;
            height: 21px;
            border: 1px solid #f0f0f0;
            vertical-align: text-bottom;
            flex-shrink: 0;
            margin-top: 3px;
            border-radius: 4px;
          }
          .earlist-right-country {
            margin-left: 12px;
            display: inline-block;
            width: 80px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            flex-shrink: 0;
            font-weight: 700;
            line-height: 26px;
          }
          .earlist-right-earlist {
            margin-left: 30px;
            display: flex;
            width: 600px;
            flex-wrap: wrap;
            span {
              margin-right: 10px;
              height: 26px;
              background-color: #eff5fc;
              border-radius: 4px;
              line-height: 26px;
              font-size: 14px;
              padding: 0 10px 0;
              margin-bottom: 10px;
            }
          }
          .earlist-right-update {
            margin-left: 100px;
            display: inline-block;
            color: #aaaaaa;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/EmbassyHoliday.vue